var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyCuisine = function SvgHappyCuisine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FDF6E9",
    d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAA839",
    fillRule: "evenodd",
    d: "M16 10a6 6 0 1 1-12 0 6 6 0 0 1 12 0m-3-1.393A1.513 1.513 0 0 0 11.607 7a1.513 1.513 0 0 0-1.393 1.607 1.59 1.59 0 0 0 1 1.537.11.11 0 0 1 .072.102v2.433a.322.322 0 0 0 .643 0v-2.433a.11.11 0 0 1 .072-.102A1.59 1.59 0 0 0 13 8.607M9.237 7.094a.321.321 0 0 1 .549.227v1.072a1.39 1.39 0 0 1-.995 1.333.11.11 0 0 0-.077.103v2.85a.322.322 0 0 1-.643 0v-2.85a.11.11 0 0 0-.076-.105A1.39 1.39 0 0 1 7 8.393V7.32a.321.321 0 1 1 .643 0v1.072a.74.74 0 0 0 .25.556.107.107 0 0 0 .178-.08V7.32a.321.321 0 1 1 .643 0V8.87a.108.108 0 0 0 .124.107.1.1 0 0 0 .055-.026.74.74 0 0 0 .25-.557V7.32c0-.085.034-.167.094-.227",
    clipRule: "evenodd"
  })));
};
export default SvgHappyCuisine;